import { Box, Divider, PolarChart, Typography } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from 'assets/images/sdg-logo.svg';
import Categories from 'assets/images/sdg-categories.svg';
import Info from 'assets/icons/info-outlined.svg';
import { Legend } from './ESGRelevanceMapping.styled';
import { ESGRelevanceMappingProps } from './ESGRelevanceMapping.d';
import { RelevanceMapping } from '../types';

const getChartData = (data?: RelevanceMapping) => {
  if (!data) return [];

  return [
    { name: 'No Poverty', color: '#e5243b', value: data.sdg01 },
    { name: 'Zero Hunger', color: '#dda63a', value: data.sdg02 },
    { name: 'Good Health and Well-being', color: '#4c9f38', value: data.sdg03 },
    { name: 'Quality Education', color: '#c5192d', value: data.sdg04 },
    { name: 'Gender Equality', color: '#ff3a21', value: data.sdg05 },
    { name: 'Clean Water and Sanitation', color: '#26bde2', value: data.sdg06 },
    { name: 'Affordable and Clean Energy', color: '#fcc30b', value: data.sdg07 },
    { name: 'Decent Work and Economic Growth', color: '#a21942', value: data.sdg08 },
    { name: 'Industry, Innovation and Infrastructure', color: '#fd6925', value: data.sdg09 },
    { name: 'Reduced Inequalities', color: '#dd1367', value: data.sdg10 },
    { name: 'Sustainable Cities and Communities', color: '#fd9d24', value: data.sdg11 },
    { name: 'Responsible Consumption and Production', color: '#bf8b2e', value: data.sdg12 },
    { name: 'Climate Action', color: '#3f7e44', value: data.sdg13 },
    { name: 'Life Below Water', color: '#0a97d9', value: data.sdg14 },
    { name: 'Life On Land', color: '#56c02b', value: data.sdg15 },
    { name: 'Peace, Justice and Strong Institutions', color: '#00689d', value: data.sdg16 },
    { name: 'Partnerships for the Goals', color: '#19486a', value: data.sdg17 },
  ];
};

export const ESGRelevanceMapping: FC<ESGRelevanceMappingProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" p={2} gridGap={2}>
      <Box display="flex" my={1} gridGap={2} alignItems="center" justifyContent="space-between">
        <Typography variant="sectionHeader" color={COLORS.typography.label}>
          {t('SDG Relevance Mapping')}
        </Typography>
        <Logo />
      </Box>
      <Divider />
      <Box display="flex" gridGap={8} justifyContent="space-between" p={2}>
        <Box display="flex" justifyContent="center" flex={1}>
          <PolarChart data={getChartData(data)} />
        </Box>
        <Legend display="flex" gridGap={8} flexDirection="column">
          <Box display="flex" alignItems="center" gridGap={2}>
            <Info width={SIZES.spacing(2.25)} height={SIZES.spacing(2.25)} />
            <Typography variant="body2" color={COLORS.typography.main}>
              {t(`A high SDG relevance signals that the sectoral activity of the company is important
              for goal achievement in operating countries with low achievement level on the
              respective goal.`)}
            </Typography>
          </Box>
          <Categories />
        </Legend>
      </Box>
    </Box>
  );
};
